import { StateValue } from './states';

type CityList = Array<{ value: string; label: string }>;
type CitiesByState = Record<StateValue, CityList>;

export const cities: CitiesByState = {
  'andaman-and-nicobar': [
    { value: 'afradganj', label: 'Afradganj' },
    { value: 'bambooflat', label: 'Bambooflat' },
    { value: 'billiground', label: 'Billiground' },
    { value: 'blairmountain', label: 'Blairmountain' },
    { value: 'car-nicobar', label: 'Car Nicobar' },
    { value: 'cuthbert-bay', label: 'Cuthbert Bay' },
    { value: 'diglipur', label: 'Diglipur' },
    { value: 'hut-bay', label: 'Hut Bay' },
    { value: 'inland-point', label: 'Inland Point' },
    { value: 'kadamtala', label: 'Kadamtala' },
    { value: 'kalpong', label: 'Kalpong' },
    { value: 'kamorta', label: 'Kamorta' },
    { value: 'katchal', label: 'Katchal' },
    { value: 'little-andaman', label: 'Little Andaman' },
    { value: 'long-island', label: 'Long Island' },
    { value: 'manglutan', label: 'Manglutan' },
    { value: 'mayabunder', label: 'Mayabunder' },
    { value: 'middle-strait', label: 'Middle Strait' },
    { value: 'nancowry', label: 'Nancowry' },
    { value: 'nicobar', label: 'Nicobar' },
    { value: 'north-bay', label: 'North Bay' },
    { value: 'passage-island', label: 'Passage Island' },
    { value: 'port-blair', label: 'Port Blair' },
    { value: 'rangat', label: 'Rangat' },
    { value: 'ross-island', label: 'Ross Island' },
    { value: 'rutland-island', label: 'Rutland Island' },
    { value: 'shippighat', label: 'Shippighat' },
    { value: 'south-button', label: 'South Button' },
    { value: 'south-point', label: 'South Point' },
    { value: 'strait-island', label: 'Strait Island' },
    { value: 'teressa', label: 'Teressa' },
    { value: 'twin-islands', label: 'Twin Islands' },
    { value: 'viper-island', label: 'Viper Island' },
    { value: 'wandoor', label: 'Wandoor' }
],
  'andhra-pradesh': [
    { value: 'adoni', label: 'Adoni' },
    { value: 'amaravati', label: 'Amaravati' },
    { value: 'anantapur', label: 'Anantapur' },
    { value: 'bhimavaram', label: 'Bhimavaram' },
    { value: 'chilakaluripet', label: 'Chilakaluripet' },
    { value: 'chittoor', label: 'Chittoor' },
    { value: 'dharmavaram', label: 'Dharmavaram' },
    { value: 'eluru', label: 'Eluru' },
    { value: 'gudivada', label: 'Gudivada' },
    { value: 'guntakal', label: 'Guntakal' },
    { value: 'guntur', label: 'Guntur' },
    { value: 'hindupuram', label: 'Hindupuram' },
    { value: 'kadapa', label: 'Kadapa' },
    { value: 'kakinada', label: 'Kakinada' },
    { value: 'kurnool', label: 'Kurnool' },
    { value: 'machilipatnam', label: 'Machilipatnam' },
    { value: 'madanapalle', label: 'Madanapalle' },
    { value: 'nandyal', label: 'Nandyal' },
    { value: 'narasaraopet', label: 'Narasaraopet' },
    { value: 'nellore', label: 'Nellore' },
    { value: 'ongole', label: 'Ongole' },
    { value: 'proddatur', label: 'Proddatur' },
    { value: 'rajamundry', label: 'Rajamundry' },
    { value: 'srikakulam', label: 'Srikakulam' },
    { value: 'tadepalligudem', label: 'Tadepalligudem' },
    { value: 'tadipatri', label: 'Tadipatri' },
    { value: 'tenali', label: 'Tenali' },
    { value: 'tirupati', label: 'Tirupati' },
    { value: 'vijayawada', label: 'Vijayawada' },
    { value: 'visakhapatnam', label: 'Visakhapatnam' },
    { value: 'vizianagaram', label: 'Vizianagaram' }
],
  'arunachal-pradesh': [
    { value: 'aalo', label: 'Aalo' },
    { value: 'anjaw', label: 'Anjaw' },
    { value: 'bameng', label: 'Bameng' },
    { value: 'basar', label: 'Basar' },
    { value: 'boleng', label: 'Boleng' },
    { value: 'bomdila', label: 'Bomdila' },
    { value: 'bordumsa', label: 'Bordumsa' },
    { value: 'borduria', label: 'Borduria' },
    { value: 'changlang', label: 'Changlang' },
    { value: 'chowkham', label: 'Chowkham' },
    { value: 'dambuk', label: 'Dambuk' },
    { value: 'daporijo', label: 'Daporijo' },
    { value: 'deomali', label: 'Deomali' },
    { value: 'dirang', label: 'Dirang' },
    { value: 'dirang-h.q', label: 'Dirang H.Q' },
    { value: 'east-kameng', label: 'East Kameng' },
    { value: 'east-siang', label: 'East Siang' },
    { value: 'gelling', label: 'Gelling' },
    { value: 'hawai', label: 'Hawai' },
    { value: 'itanagar', label: 'Itanagar' },
    { value: 'jairampur', label: 'Jairampur' },
    { value: 'khonsa', label: 'Khonsa' },
    { value: 'lathao', label: 'Lathao' },
    { value: 'lhou', label: 'Lhou' },
    { value: 'lower-subansiri', label: 'Lower Subansiri' },
    { value: 'naharlagun', label: 'Naharlagun' },
    { value: 'namsai', label: 'Namsai' },
    { value: 'nacho', label: 'Nacho' },
    { value: 'pangin', label: 'Pangin' },
    { value: 'pasighat', label: 'Pasighat' },
    { value: 'roing', label: 'Roing' },
    { value: 'sagalee', label: 'Sagalee' },
    { value: 'seppa', label: 'Seppa' },
    { value: 'taliha', label: 'Taliha' },
    { value: 'tawang', label: 'Tawang' },
    { value: 'tezu', label: 'Tezu' },
    { value: 'thingbu', label: 'Thingbu' },
    { value: 'vijoynagar', label: 'Vijoynagar' },
    { value: 'wakro', label: 'Wakro' },
    { value: 'yupia', label: 'Yupia' },
    { value: 'yingkiong', label: 'Yingkiong' },
    { value: 'ziro', label: 'Ziro' },
    { value: 'zemithang', label: 'Zemithang' }
],
  'assam': [
    { value: 'amguri', label: 'Amguri' },
    { value: 'baksa', label: 'Baksa' },
    { value: 'bambooflat', label: 'Bambooflat' },
    { value: 'barpeta', label: 'Barpeta' },
    { value: 'bijni', label: 'Bijni' },
    { value: 'bilasipara', label: 'Bilasipara' },
    { value: 'biswanath-charali', label: 'Biswanath Charali' },
    { value: 'bongaigaon', label: 'Bongaigaon' },
    { value: 'bokakhat', label: 'Bokakhat' },
    { value: 'chabua-town', label: 'Chabua-Town' },
    { value: 'chapar', label: 'Chapar' },
    { value: 'dhekiajuli', label: 'Dhekiajuli' },
    { value: 'dhemaji', label: 'Dhemaji' },
    { value: 'dhubri', label: 'Dhubri' },
    { value: 'dibrugarh', label: 'Dibrugarh' },
    { value: 'digboi', label: 'Digboi' },
    { value: 'diphu', label: 'Diphu' },
    { value: 'doom-dooma', label: 'Doom dooma' },
    { value: 'dergaon', label: 'Dergaon' },
    { value: 'gauripur', label: 'Gauripur' },
    { value: 'goalpara', label: 'Goalpara' },
    { value: 'golaghat', label: 'Golaghat' },
    { value: 'guwahati', label: 'Guwahati' },
    { value: 'hailakandi', label: 'Hailakandi' },
    { value: 'hajo', label: 'Hajo' },
    { value: 'haflong', label: 'Haflong' },
    { value: 'hojai', label: 'Hojai' },
    { value: 'jatinga', label: 'Jatinga' },
    { value: 'jogighopa', label: 'Jogighopa' },
    { value: 'jorhat', label: 'Jorhat' },
    { value: 'kharupetia', label: 'Kharupetia' },
    { value: 'kokrajhar', label: 'Kokrajhar' },
    { value: 'lanka', label: 'Lanka' },
    { value: 'lakhipur', label: 'Lakhipur' },
    { value: 'lumding', label: 'Lumding' },
    { value: 'maibang', label: 'Maibang' },
    { value: 'mangaldoi', label: 'Mangaldoi' },
    { value: 'mankachar', label: 'Mankachar' },
    { value: 'margherita', label: 'Margherita' },
    { value: 'mariani', label: 'Mariani' },
    { value: 'moranhat', label: 'Moranhat' },
    { value: 'morigaon', label: 'Morigaon' },
    { value: 'mushalpur', label: 'Mushalpur' },
    { value: 'nagaon', label: 'Nagaon' },
    { value: 'nalbari', label: 'Nalbari' },
    { value: 'nazira', label: 'Nazira' },
    { value: 'north-lakhimpur', label: 'North Lakhimpur' },
    { value: 'palasbari', label: 'Palasbari' },
    { value: 'pathsala', label: 'Pathsala' },
    { value: 'rangapara', label: 'Rangapara' },
    { value: 'rangia', label: 'Rangia' },
    { value: 'siddhpur', label: 'Siddhpur' },
    { value: 'silapathar', label: 'Silapathar' },
    { value: 'silchar', label: 'Silchar' },
    { value: 'sivasagar', label: 'Sivasagar' },
    { value: 'sonari', label: 'Sonari' },
    { value: 'sonitpur', label: 'Sonitpur' },
    { value: 'tangla', label: 'Tangla' },
    { value: 'tezpur', label: 'Tezpur' },
    { value: 'teok', label: 'Teok' },
    { value: 'tihu', label: 'Tihu' },
    { value: 'tinsukia', label: 'Tinsukia' },
    { value: 'titabar', label: 'Titabar' },
    { value: 'udalguri', label: 'Udalguri' }
],
  'bihar': [
    { value: 'aurangabad.', label: 'Aurangabad.' },
    { value: 'bagaha', label: 'Bagaha' },
    { value: 'begusarai', label: 'Begusarai' },
    { value: 'bettiah', label: 'Bettiah' },
    { value: 'bhagalpur', label: 'Bhagalpur' },
    { value: 'buxar', label: 'Buxar' },
    { value: 'chhapra', label: 'Chhapra' },
    { value: 'danapur', label: 'Danapur' },
    { value: 'darbhanga', label: 'Darbhanga' },
    { value: 'dehri', label: 'Dehri' },
    { value: 'gaya', label: 'Gaya' },
    { value: 'hajipur', label: 'Hajipur' },
    { value: 'jamalpur', label: 'Jamalpur' },
    { value: 'jehanabad', label: 'Jehanabad' },
    { value: 'katihar', label: 'Katihar' },
    { value: 'kishanganj', label: 'Kishanganj' },
    { value: 'munger', label: 'Munger' },
    { value: 'motihari', label: 'Motihari' },
    { value: 'muzaffarpur', label: 'Muzaffarpur' },
    { value: 'nawada', label: 'Nawada' },
    { value: 'patna', label: 'Patna' },
    { value: 'purnia', label: 'Purnia' },
    { value: 'saharsa', label: 'Saharsa' },
    { value: 'sasaram', label: 'Sasaram' },
    { value: 'sharif-arrah', label: 'Sharif Arrah' },
    { value: 'siwan', label: 'Siwan' },
    { value: 'sitamarhi', label: 'Sitamarhi' }
],
  'chandigarh': [
    { value: 'behlana', label: 'Behlana' },
    { value: 'burail', label: 'Burail' },
    { value: 'chandimandir', label: 'Chandimandir' },
    { value: 'daria', label: 'Daria' },
    { value: 'daddu-mazra', label: 'Daddu Mazra' },
    { value: 'indira-colony', label: 'Indira Colony' },
    { value: 'industrial-area-phase-1', label: 'Industrial Area Phase 1' },
    { value: 'industrial-area-phase-2', label: 'Industrial Area Phase 2' },
    { value: 'kansal', label: 'Kansal' },
    { value: 'khuda-alisher', label: 'Khuda Alisher' },
    { value: 'khuda-lahora', label: 'Khuda Lahora' },
    { value: 'khuda-jassu', label: 'Khuda Jassu' },
    { value: 'mauli-jagran', label: 'Mauli Jagran' },
    { value: 'manimajra', label: 'Manimajra' },
    { value: 'palsora', label: 'Palsora' },
    { value: 'panchkula', label: 'Panchkula' },
    { value: 'raipur-kalan', label: 'Raipur Kalan' },
    { value: 'raipur-khurd', label: 'Raipur Khurd' },
    { value: 'ram-darbar', label: 'Ram Darbar' },
    { value: 'sector-1', label: 'Sector 1' },
    { value: 'sector-10', label: 'Sector 10' },
    { value: 'sector-11', label: 'Sector 11' },
    { value: 'sector-12', label: 'Sector 12' },
    { value: 'sector-15', label: 'Sector 15' },
    { value: 'sector-17', label: 'Sector 17' },
    { value: 'sector-20', label: 'Sector 20' },
    { value: 'sector-21', label: 'Sector 21' },
    { value: 'sector-22', label: 'Sector 22' },
    { value: 'sector-25', label: 'Sector 25' },
    { value: 'sector-30', label: 'Sector 30' },
    { value: 'sector-32', label: 'Sector 32' },
    { value: 'sector-35', label: 'Sector 35' },
    { value: 'sector-38', label: 'Sector 38' },
    { value: 'sector-40', label: 'Sector 40' },
    { value: 'sector-44', label: 'Sector 44' },
    { value: 'sector-45', label: 'Sector 45' },
    { value: 'sector-50', label: 'Sector 50' },
    { value: 'sector-51', label: 'Sector 51' },
    { value: 'sector-52', label: 'Sector 52' },
    { value: 'sector-61', label: 'Sector 61' },
    { value: 'sector-63', label: 'Sector 63' },
    { value: 'sarangpur', label: 'Sarangpur' },
    { value: 'village-attawa', label: 'Village Attawa' },
    { value: 'village-badheri', label: 'Village Badheri' },
    { value: 'village-bapudham', label: 'Village Bapudham' },
    { value: 'village-burail', label: 'Village Burail' },
    { value: 'village-faida', label: 'Village Faida' },
    { value: 'village-khuda-ali-sher', label: 'Village Khuda Ali Sher' },
    { value: 'village-khuda-jassu', label: 'Village Khuda Jassu' },
    { value: 'village-khuda-lahora', label: 'Village Khuda Lahora' },
    { value: 'village-maloya', label: 'Village Maloya' },
    { value: 'village-raipur-kalan', label: 'Village Raipur Kalan' },
    { value: 'village-raipur-khurd', label: 'Village Raipur Khurd' },
    { value: 'village-sarangpur', label: 'Village Sarangpur' },
    { value: 'village-dhanas', label: 'Village Dhanas' },
    { value: 'zirakpur', label: 'Zirakpur' }
],
  'chhattisgarh': [
    { value: 'ambikapur', label: 'Ambikapur' },
    { value: 'antagarh', label: 'Antagarh' },
    { value: 'baikunthpur', label: 'Baikunthpur' },
    { value: 'balod', label: 'Balod' },
    { value: 'baloda-bazar', label: 'Baloda Bazar' },
    { value: 'balrampur', label: 'Balrampur' },
    { value: 'bemetara', label: 'Bemetara' },
    { value: 'bhilai', label: 'Bhilai' },
    { value: 'bijapur', label: 'Bijapur' },
    { value: 'bilaspur', label: 'Bilaspur' },
    { value: 'bilha', label: 'Bilha' },
    { value: 'bishrampur', label: 'Bishrampur' },
    { value: 'champa', label: 'Champa' },
    { value: 'chhura', label: 'Chhura' },
    { value: 'chhuikhadan', label: 'Chhuikhadan' },
    { value: 'chirimiri', label: 'Chirimiri' },
    { value: 'dantewada', label: 'Dantewada' },
    { value: 'dhamtari', label: 'Dhamtari' },
    { value: 'durg', label: 'Durg' },
    { value: 'dongargaon', label: 'Dongargaon' },
    { value: 'fingeshwar', label: 'Fingeshwar' },
    { value: 'gaurella', label: 'Gaurella' },
    { value: 'gariyaband', label: 'Gariyaband' },
    { value: 'gundardehi', label: 'Gundardehi' },
    { value: 'jagdalpur', label: 'Jagdalpur' },
    { value: 'jashpur-nagar', label: 'Jashpur Nagar' },
    { value: 'kanker', label: 'Kanker' },
    { value: 'kawardha', label: 'Kawardha' },
    { value: 'khairagarh', label: 'Khairagarh' },
    { value: 'kharod', label: 'Kharod' },
    { value: 'kondagaon.', label: 'Kondagaon' },
    { value: 'korba', label: 'Korba' },
    { value: 'kumhari', label: 'Kumhari' },
    { value: 'kunkuri', label: 'Kunkuri' },
    { value: 'kurud', label: 'Kurud' },
    { value: 'mahasamund', label: 'Mahasamund' },
    { value: 'manendragarh', label: 'Manendragarh' },
    { value: 'mungeli', label: 'Mungeli' },
    { value: 'nagri', label: 'Nagri' },
    { value: 'ramanujganj', label: 'Ramanujganj' },
    { value: 'raigarh', label: 'Raigarh' },
    { value: 'raipur', label: 'Raipur' },
    { value: 'rajim', label: 'Rajim' },
    { value: 'rajnandgaon', label: 'Rajnandgaon' },
    { value: 'ratanpur', label: 'Ratanpur' },
    { value: 'sakti', label: 'Sakti' },
    { value: 'sarangarh', label: 'Sarangarh' },
    { value: 'simga', label: 'Simga' },
    { value: 'sukma', label: 'Sukma' },
    { value: 'surajpur', label: 'Surajpur' },
    { value: 'takhatpur', label: 'Takhatpur' }
],
  'dadra-and-nagar-haveli': [
    { value: 'dadra', label: 'Dadra' },
    { value: 'silvassa', label: 'Silvassa' },
    { value: 'naroli', label: 'Naroli' },
    { value: 'vasona', label: 'Vasona' },
    { value: 'khadoli', label: 'Khadoli' },
    { value: 'khanvel', label: 'Khanvel' },
    { value: 'dungra', label: 'Dungra' },
    { value: 'patti', label: 'Patti' },
    { value: 'gora', label: 'Gora' },
    { value: 'mangrol', label: 'Mangrol' },
    { value: 'rangpur', label: 'Rangpur' },
    { value: 'garacharma', label: 'Garacharma' },
    { value: 'tadvi', label: 'Tadvi' },
    { value: 'tapsi', label: 'Tapsi' },
    { value: 'malwan', label: 'Malwan' },
    { value: 'ankadi', label: 'Ankadi' },
    { value: 'chhapra', label: 'Chhapra' },
    { value: 'patelwadi', label: 'Patelwadi' },
    { value: 'malbari', label: 'Malbari' },
    { value: 'dabhel', label: 'Dabhel' },
    { value: 'tithal', label: 'Tithal' },
    { value: 'tandel', label: 'Tandel' },
    { value: 'bhilad', label: 'Bhilad' },
    { value: 'varachha', label: 'Varachha' },
    { value: 'pali', label: 'Pali' }
],
  'daman-and-diu': [
    { value: 'damao', label: 'Damao' },
    { value: 'damanas', label: 'Damanas' },
    { value: 'damaun', label: 'Damaun' },
    { value: 'dholar', label: 'Dholar' },
    { value: 'div', label: 'Div' },
    { value: 'doler', label: 'Doler' },
    { value: 'ghaniwar', label: 'Ghaniwar' },
    { value: 'ghāntwar', label: 'Ghāntwar' },
    { value: 'gogla', label: 'Gogla' },
    { value: 'gogola', label: 'Gogola' },
    { value: 'kotda', label: 'Kotda' },
    { value: 'marvad', label: 'Marvad' },
    { value: 'marvor', label: 'Marvor' },
    { value: 'sarkharia', label: 'Sarkharia' },
    { value: 'sigsar', label: 'Sigsar' }
],
  'delhi': [
    { value: 'abhay-khand', label: 'Abhay Khand' },
    { value: 'adarsh-nagar', label: 'Adarsh Nagar' },
    { value: 'akash-vihar', label: 'Akash Vihar' },
    { value: 'alipur', label: 'Alipur' },
    { value: 'alok-vihar', label: 'Alok Vihar' },
    { value: 'ambarhai', label: 'Ambarhai' },
    { value: 'andha-mughal', label: 'Andha Mughal' },
    { value: 'anupam-garden', label: 'Anupam Garden' },
    { value: 'arjun-nagar', label: 'Arjun Nagar' },
    { value: 'ashok-nagar', label: 'Ashok Nagar' },
    { value: 'ashok-vihar', label: 'Ashok Vihar' },
    { value: 'ashram', label: 'Ashram' },
    { value: 'aujla-village', label: 'Aujla Village' },
    { value: 'avinash-vihar', label: 'Avinash Vihar' },
    { value: 'azadpur', label: 'Azadpur' },
    { value: 'baljeet-nagar', label: 'Baljeet Nagar' },
    { value: 'bali-nagar', label: 'Bali Nagar' },
    { value: 'baljit-vihar', label: 'Baljit Vihar' },
    { value: 'bawana', label: 'Bawana' },
    { value: 'bhajanpura', label: 'Bhajanpura' },
    { value: 'bharat-nagar', label: 'Bharat Nagar' },
    { value: 'bhogal', label: 'Bhogal' },
    { value: 'bijwasan', label: 'Bijwasan' },
    { value: 'burari', label: 'Burari' },
    { value: 'central-delhi', label: 'Central Delhi' },
    { value: 'chakarpur', label: 'Chakarpur' },
    { value: 'chandni-chowk', label: 'Chandni Chowk' },
    { value: 'chanakyapuri', label: 'Chanakyapuri' },
    { value: 'chattarpur', label: 'Chattarpur' },
    { value: 'cheeranjiv-vihar', label: 'Cheeranjiv Vihar' },
    { value: 'chhatarpur', label: 'Chhatarpur' },
    { value: 'chhawla', label: 'Chhawla' },
    { value: 'chittaranjan-park', label: 'Chittaranjan Park (CR Park)' },
    { value: 'civil-lines', label: 'Civil Lines' },
    { value: 'connaught-place', label: 'Connaught Place' },
    { value: 'crystal-vihar', label: 'Crystal Vihar' },
    { value: 'dallupura', label: 'Dallupura' },
    { value: 'daryaganj', label: 'Daryaganj' },
    { value: 'dashrathpuri', label: 'Dashrathpuri' },
    { value: 'dayalpur', label: 'Dayalpur' },
    { value: 'dayanand-vihar', label: 'Dayanand Vihar' },
    { value: 'defence-colony', label: 'Defence Colony' },
    { value: 'delhi', label: 'Delhi' },
    { value: 'dera-village', label: 'Dera Village' },
    { value: 'devli', label: 'Devli' },
    { value: 'dilshad-garden', label: 'Dilshad Garden' },
    { value: 'dwarka', label: 'Dwarka' },
    { value: 'dwarka-sector-1', label: 'Dwarka Sector 1' },
    { value: 'dwarka-sector-10', label: 'Dwarka Sector 10' },
    { value: 'dwarka-sector-12', label: 'Dwarka Sector 12' },
    { value: 'dwarka-sector-22', label: 'Dwarka Sector 22' },
    { value: 'east-delhi', label: 'East Delhi' },
    { value: 'friends-colony', label: 'Friends Colony' },
    { value: 'gandhi-nagar', label: 'Gandhi Nagar' },
    { value: 'geeta-colony', label: 'Geeta Colony' },
    { value: 'ghitorni', label: 'Ghitorni' },
    { value: 'govindpuri', label: 'Govindpuri' },
    { value: 'greater-kailash', label: 'Greater Kailash' },
    { value: 'green-park', label: 'Green Park' },
    { value: 'hauz-khas', label: 'Hauz Khas' },
    { value: 'janakpuri', label: 'Janakpuri' },
    { value: 'jasola', label: 'Jasola' },
    { value: 'jharoda', label: 'Jharoda' },
    { value: 'karampura', label: 'Karampura' },
    { value: 'karol-bagh', label: 'Karol Bagh' },
    { value: 'kalkaji', label: 'Kalkaji' },
    { value: 'kalyanpuri', label: 'Kalyanpuri' },
    { value: 'khan-market', label: 'Khan Market' },
    { value: 'khirki-extension', label: 'Khirki Extension' },
    { value: 'kondli', label: 'Kondli' },
    { value: 'lajpat-nagar', label: 'Lajpat Nagar' },
    { value: 'lal-kuan', label: 'Lal Kuan' },
    { value: 'madangir', label: 'Madangir' },
    { value: 'mahavir-enclave', label: 'Mahavir Enclave' },
    { value: 'mahipalpur', label: 'Mahipalpur' },
    { value: 'malviya-nagar', label: 'Malviya Nagar' },
    { value: 'maujpur', label: 'Maujpur' },
    { value: 'mayur-vihar', label: 'Mayur Vihar' },
    { value: 'mehrauli', label: 'Mehrauli' },
    { value: 'mohan-garden', label: 'Mohan Garden' },
    { value: 'model-town', label: 'Model Town' },
    { value: 'moti-bagh', label: 'Moti Bagh' },
    { value: 'munirka', label: 'Munirka' },
    { value: 'najafgarh', label: 'Najafgarh' },
    { value: 'nand-nagri', label: 'Nand Nagri' },
    { value: 'naraina', label: 'Naraina' },
    { value: 'nehru-place', label: 'Nehru Place' },
    { value: 'new-delhi', label: 'New Delhi' },
    { value: 'new-friends-colony', label: 'New Friends Colony' },
    { value: 'north-delhi', label: 'North Delhi' },
    { value: 'okhla', label: 'Okhla' },
    { value: 'palam', label: 'Palam' },
    { value: 'paschim-vihar', label: 'Paschim Vihar' },
    { value: 'pitampura', label: 'Pitampura' },
    { value: 'punjabi-bagh', label: 'Punjabi Bagh' },
    { value: 'qutub-vihar', label: 'Qutub Vihar' },
    { value: 'rajouri-garden', label: 'Rajouri Garden' },
    { value: 'rohini', label: 'Rohini' },
    { value: 'saket', label: 'Saket' },
    { value: 'sarita-vihar', label: 'Sarita Vihar' },
    { value: 'shahdara', label: 'Shahdara' },
    { value: 'shalimar-bagh', label: 'Shalimar Bagh' },
    { value: 'south-delhi', label: 'South Delhi' },
    { value: 'south-extension', label: 'South Extension' },
    { value: 'tilak-nagar', label: 'Tilak Nagar' },
    { value: 'uttam-nagar', label: 'Uttam Nagar' },
    { value: 'vasant-kunj', label: 'Vasant Kunj' },
    { value: 'vasant-vihar', label: 'Vasant Vihar' },
    { value: 'vikaspuri', label: 'Vikaspuri' },
    { value: 'vivek-vihar', label: 'Vivek Vihar' },
    { value: 'wazirabad', label: 'Wazirabad' },
    { value: 'west-delhi', label: 'West Delhi' }
],
'goa': [
    { value: 'goa', label: 'Goa' },
    { value: 'alorna', label: 'Alorna' },
    { value: 'anjuna', label: 'Anjuna' },
    { value: 'arambol', label: 'Arambol' },
    { value: 'assonora', label: 'Assonora' },
    { value: 'benaulim', label: 'Benaulim' },
    { value: 'bhati', label: 'Bhati' },
    { value: 'dicholi', label: 'Dicholi' },
    { value: 'candolim', label: 'Candolim' },
    { value: 'caranzalem', label: 'Caranzalem' },
    { value: 'chandor', label: 'Chandor' },
    { value: 'cansaulim', label: 'Cansaulim' },
    { value: 'colva', label: 'Colva' },
    { value: 'cortalim', label: 'Cortalim' },
    { value: 'curti', label: 'Curti' },
    { value: 'dona-paula', label: 'Dona Paula' },
    { value: 'guirim', label: 'Guirim' },
    { value: 'kavlem', label: 'Kavlem' },
    { value: 'loutolim', label: 'Loutolim' },
    { value: 'madgaon', label: 'Madgaon' },
    { value: 'majorda', label: 'Majorda' },
    { value: 'mapusa', label: 'Mapusa' },
    { value: 'margao', label: 'Margao' },
    { value: 'mollem', label: 'Mollem' },
    { value: 'monte', label: 'Monte' },
    { value: 'nuvem', label: 'Nuvem' },
    { value: 'panaji', label: 'Panaji' },
    { value: 'pilar', label: 'Pilar' },
    { value: 'ponda', label: 'Ponda' },
    { value: 'quepem', label: 'Quepem' },
    { value: 'rassaim', label: 'Rassaim' },
    { value: 'sanguem', label: 'Sanguem' },
    { value: 'shiroda', label: 'Shiroda' },
    { value: 'south-goa', label: 'South Goa' },
    { value: 'saligao', label: 'Saligao' },
    { value: 'serula', label: 'Serula' },
    { value: 'tivim', label: 'Tivim' },
    { value: 'vasco-da-gama', label: 'Vasco da Gama' }
],
  'gujarat': [
    { value: 'ahmedabad', label: 'Ahmedabad' },
    { value: 'ahwa', label: 'Ahwa' },
    { value: 'amreli', label: 'Amreli' },
    { value: 'anand', label: 'Anand' },
    { value: 'ankleshwar', label: 'Ankleshwar' },
    { value: 'bharuch', label: 'Bharuch' },
    { value: 'bhavnagar', label: 'Bhavnagar' },
    { value: 'botad', label: 'Botad' },
    { value: 'chaklasi', label: 'Chaklasi' },
    { value: 'chhota-udepur', label: 'Chhota Udepur' },
    { value: 'dahod', label: 'Dahod' },
    { value: 'dhoraji', label: 'Dhoraji' },
    { value: 'dudhrej', label: 'Dudhrej' },
    { value: 'dwarka.', label: 'Dwarka' },
    { value: 'gandhinagar', label: 'Gandhinagar' },
    { value: 'godhra', label: 'Godhra' },
    { value: 'gondal', label: 'Gondal' },
    { value: 'jamnagar', label: 'Jamnagar' },
    { value: 'jasdan', label: 'Jasdan' },
    { value: 'jetpur', label: 'Jetpur' },
    { value: 'junagadh', label: 'Junagadh' },
    { value: 'kandla', label: 'Kandla' },
    { value: 'katihar', label: 'Katihar' }, // Confirm if 'Katihar' belongs to Gujarat, as it seems out of place.
    { value: 'khambhalia', label: 'Khambhalia' },
    { value: 'khambhat', label: 'Khambhat' },
    { value: 'kheda', label: 'Kheda' },
    { value: 'limkheda', label: 'Limkheda' },
    { value: 'lathi', label: 'Lathi' },
    { value: 'lunawada', label: 'Lunawada' },
    { value: 'mehsana', label: 'Mehsana' },
    { value: 'modasa', label: 'Modasa' },
    { value: 'morbi', label: 'Morbi' },
    { value: 'navsari', label: 'Navsari' },
    { value: 'paddhari', label: 'Paddhari' },
    { value: 'palanpur', label: 'Palanpur' },
    { value: 'patan', label: 'Patan' },
    { value: 'porbandar', label: 'Porbandar' },
    { value: 'prantij', label: 'Prantij' },
    { value: 'rajkot', label: 'Rajkot' },
    { value: 'rajpipla', label: 'Rajpipla' },
    { value: 'radhanpur', label: 'Radhanpur' },
    { value: 'siddhpur', label: 'Siddhpur' },
    { value: 'sihor', label: 'Sihor' },
    { value: 'songadh', label: 'Songadh' },
    { value: 'surat', label: 'Surat' },
    { value: 'upleta', label: 'Upleta' },
    { value: 'valsad', label: 'Valsad' },
    { value: 'vadodara', label: 'Vadodara' },
    { value: 'veraval', label: 'Veraval' },
    { value: 'vyara', label: 'Vyara' }
],
  'haryana': [
    { value: 'ambala', label: 'Ambala' },
    { value: 'assandh', label: 'Assandh' },
    { value: 'bahadurgarh', label: 'Bahadurgarh' },
    { value: 'bawal', label: 'Bawal' },
    { value: 'bawani-khera', label: 'Bawani Khera' },
    { value: 'bhiwani', label: 'Bhiwani' },
    { value: 'chhachhrauli', label: 'Chhachhrauli' },
    { value: 'ellenabad', label: 'Ellenabad' },
    { value: 'faridabad', label: 'Faridabad' },
    { value: 'fatehabad', label: 'Fatehabad' },
    { value: 'firozpur-jhirka', label: 'Firozpur Jhirka' },
    { value: 'ganaur', label: 'Ganaur' },
    { value: 'gharaunda', label: 'Gharaunda' },
    { value: 'gohana', label: 'Gohana' },
    { value: 'gurugram', label: 'Gurugram' },
    { value: 'hansi', label: 'Hansi' },
    { value: 'hathin', label: 'Hathin' },
    { value: 'hisar', label: 'Hisar' },
    { value: 'jagadhri', label: 'Jagadhri' },
    { value: 'jhajjar', label: 'Jhajjar' },
    { value: 'jind', label: 'Jind' },
    { value: 'kansapur', label: 'Kansapur' },
    { value: 'kardhan', label: 'Kardhan' },
    { value: 'kaithal', label: 'Kaithal' },
    { value: 'karnal', label: 'Karnal' },
    { value: 'kurukshetra', label: 'Kurukshetra' },
    { value: 'loharu', label: 'Loharu' },
    { value: 'mahendragarh', label: 'Mahendragarh' },
    { value: 'meham', label: 'Meham' },
    { value: 'narnaul', label: 'Narnaul' },
    { value: 'narwana', label: 'Narwana' },
    { value: 'naraingarh', label: 'Naraingarh' },
    { value: 'nuh', label: 'Nuh' },
    { value: 'palwal', label: 'Palwal' },
    { value: 'panchkula', label: 'Panchkula' },
    { value: 'panipat', label: 'Panipat' },
    { value: 'pataudi', label: 'Pataudi' },
    { value: 'pehowa', label: 'Pehowa' },
    { value: 'pinjore', label: 'Pinjore' },
    { value: 'punhana', label: 'Punhana' },
    { value: 'pundri', label: 'Pundri' },
    { value: 'ratia', label: 'Ratia' },
    { value: 'rewari', label: 'Rewari' },
    { value: 'rohtak', label: 'Rohtak' },
    { value: 'safidon', label: 'Safidon' },
    { value: 'samalkha', label: 'Samalkha' },
    { value: 'sasauli', label: 'Sasauli' },
    { value: 'sirsa', label: 'Sirsa' },
    { value: 'siwani', label: 'Siwani' },
    { value: 'sonipat', label: 'Sonipat' },
    { value: 'tauru', label: 'Tauru' },
    { value: 'thanesar', label: 'Thanesar' },
    { value: 'tohana', label: 'Tohana' },
    { value: 'yamuna-nagar', label: 'Yamuna Nagar' }
],
  'himachal-pradesh': [
    { value: 'arki', label: 'Arki' },
    { value: 'baddi', label: 'Baddi' },
    { value: 'banjar', label: 'Banjar' },
    { value: 'bhuntar', label: 'Bhuntar' },
    { value: 'bilaspur.', label: 'Bilaspur' },
    { value: 'chamba', label: 'Chamba' },
    { value: 'chopal', label: 'Chopal' },
    { value: 'chuari-khas', label: 'Chuari Khas' },
    { value: 'dagshai', label: 'Dagshai' },
    { value: 'dalhousie', label: 'Dalhousie' },
    { value: 'daulatpur', label: 'Daulatpur' },
    { value: 'dehra-gopipur', label: 'Dehra Gopipur' },
    { value: 'dharamshala', label: 'Dharamshala' },
    { value: 'gagret', label: 'Gagret' },
    { value: 'ghumarwin', label: 'Ghumarwin' },
    { value: 'hamirpur.', label: 'Hamirpur' },
    { value: 'indora', label: 'Indora' },
    { value: 'jawalamukhi', label: 'Jawalamukhi' },
    { value: 'joginder-nagar', label: 'Joginder Nagar' },
    { value: 'jubbal', label: 'Jubbal' },
    { value: 'jutogh', label: 'Jutogh' },
    { value: 'kangra', label: 'Kangra' },
    { value: 'kasauli', label: 'Kasauli' },
    { value: 'kotkhai', label: 'Kotkhai' },
    { value: 'kullu', label: 'Kullu' },
    { value: 'manali', label: 'Manali' },
    { value: 'mandi', label: 'Mandi' },
    { value: 'nadaun', label: 'Nadaun' },
    { value: 'nahan', label: 'Nahan' },
    { value: 'naina-devi', label: 'Naina Devi' },
    { value: 'nalagarh', label: 'Nalagarh' },
    { value: 'nagrota-bagwan', label: 'Nagrota Bagwan' },
    { value: 'narkanda', label: 'Narkanda' },
    { value: 'nurpur', label: 'Nurpur' },
    { value: 'palampur', label: 'Palampur' },
    { value: 'paonta-sahib', label: 'Paonta Sahib' },
    { value: 'parwanoo', label: 'Parwanoo' },
    { value: 'rajgarh', label: 'Rajgarh' },
    { value: 'rampur-bushahr', label: 'Rampur-Bushahr' },
    { value: 'rewalsar', label: 'Rewalsar' },
    { value: 'rohru', label: 'Rohru' },
    { value: 'sarkaghat', label: 'Sarkaghat' },
    { value: 'shimla', label: 'Shimla' },
    { value: 'sihor-pai', label: 'Sihor Pai' },
    { value: 'solan', label: 'Solan' },
    { value: 'subathu', label: 'Subathu' },
    { value: 'sujanpur-tira', label: 'Sujanpur Tira' },
    { value: 'sundar-nagar', label: 'Sundar Nagar' },
    { value: 'talai', label: 'Talai' },
    { value: 'theog', label: 'Theog' },
    { value: 'una', label: 'Una' }
],
  'jammu-and-kashmir': [
    { value: 'achabal', label: 'Achabal' },
    { value: 'akhnoor', label: 'Akhnoor' },
    { value: 'anantnag', label: 'Anantnag' },
    { value: 'arnia', label: 'Arnia' },
    { value: 'awantipora', label: 'Awantipora' },
    { value: 'baramulla', label: 'Baramulla' },
    { value: 'beerwah', label: 'Beerwah' },
    { value: 'bhaderwah', label: 'Bhaderwah' },
    { value: 'billawar', label: 'Billawar' },
    { value: 'bijbehara', label: 'Bijbehara' },
    { value: 'bishnah', label: 'Bishnah' },
    { value: 'charar-i-sharief', label: 'Charar-i-Sharief' },
    { value: 'doda', label: 'Doda' },
    { value: 'ganderbal', label: 'Ganderbal' },
    { value: 'ghou-manhasan', label: 'Ghou Manhasan' },
    { value: 'hajan', label: 'Hajan' },
    { value: 'handwara', label: 'Handwara' },
    { value: 'hiranagar', label: 'Hiranagar' },
    { value: 'jammu', label: 'Jammu' },
    { value: 'jourian', label: 'Jourian' },
    { value: 'kathua', label: 'Kathua' },
    { value: 'katra', label: 'Katra' },
    { value: 'khore', label: 'Khore' },
    { value: 'kulgam', label: 'Kulgam' },
    { value: 'kupwara', label: 'Kupwara' },
    { value: 'lakhenpur', label: 'Lakhenpur' },
    { value: 'nahan', label: 'Nahan' },
    { value: 'pahalgam', label: 'Pahalgam' },
    { value: 'pampore', label: 'Pampore' },
    { value: 'pattan', label: 'Pattan' },
    { value: 'plan-bandipora', label: 'Plan Bandipora' },
    { value: 'poonch', label: 'Poonch' },
    { value: 'pulwama', label: 'Pulwama' },
    { value: 'qaimoh', label: 'Qaimoh' },
    { value: 'qazigund', label: 'Qazigund' },
    { value: 'ramban', label: 'Ramban' },
    { value: 'ranbir-singh-pura', label: 'Ranbir Singh Pura' },
    { value: 'rajouri', label: 'Rajouri' },
    { value: 'samba', label: 'Samba' },
    { value: 'shopian', label: 'Shopian' },
    { value: 'sopore', label: 'Sopore' },
    { value: 'srinagar', label: 'Srinagar' },
    { value: 'sumbal', label: 'Sumbal' },
    { value: 'sunderbani', label: 'Sunderbani' },
    { value: 'surankote', label: 'Surankote' },
    { value: 'tangdhar', label: 'Tangdhar' },
    { value: 'thanamandi', label: 'Thanamandi' },
    { value: 'tral', label: 'Tral' },
    { value: 'udhampur', label: 'Udhampur' },
    { value: 'uri', label: 'Uri' },
    { value: 'verinag', label: 'Verinag' },
    { value: 'yaripora', label: 'Yaripora' }
],
 'jharkhand': [
    { value: 'adityapur', label: 'Adityapur' },
    { value: 'barughutu', label: 'Barughutu' },
    { value: 'bermo', label: 'Bermo' },
    { value: 'bokaro-steel-city', label: 'Bokaro Steel City' },
    { value: 'bundu', label: 'Bundu' },
    { value: 'chaibasa', label: 'Chaibasa' },
    { value: 'chakradharpur', label: 'Chakradharpur' },
    { value: 'chas', label: 'Chas' },
    { value: 'chirkunda', label: 'Chirkunda' },
    { value: 'churi', label: 'Churi' },
    { value: 'deoghar', label: 'Deoghar' },
    { value: 'dhanbad', label: 'Dhanbad' },
    { value: 'dumka', label: 'Dumka' },
    { value: 'dugda', label: 'Dugda' },
    { value: 'gadhra', label: 'Gadhra' },
    { value: 'garhwa', label: 'Garhwa' },
    { value: 'ghatshila', label: 'Ghatshila' },
    { value: 'giridih', label: 'Giridih' },
    { value: 'godda', label: 'Godda' },
    { value: 'gumla', label: 'Gumla' },
    { value: 'gumia', label: 'Gumia' },
    { value: 'hazaribagh', label: 'Hazaribagh' },
    { value: 'hussainabad', label: 'Hussainabad' },
    { value: 'jamshedpur', label: 'Jamshedpur' },
    { value: 'jamtara', label: 'Jamtara' },
    { value: 'jhumri-telaiya', label: 'Jhumri-Telaiya' },
    { value: 'kanke', label: 'Kanke' },
    { value: 'kathara', label: 'Kathara' },
    { value: 'khalari', label: 'Khalari' },
    { value: 'khunti', label: 'Khunti' },
    { value: 'koderma', label: 'Koderma' },
    { value: 'kuju', label: 'Kuju' },
    { value: 'latehar', label: 'Latehar' },
    { value: 'lohardaga', label: 'Lohardaga' },
    { value: 'madhupur', label: 'Madhupur' },
    { value: 'mango', label: 'Mango' },
    { value: 'medininagar', label: 'Medininagar' },
    { value: 'mera', label: 'Mera' },
    { value: 'mihijam', label: 'Mihijam' },
    { value: 'musabani', label: 'Musabani' },
    { value: 'pakur', label: 'Pakur' },
    { value: 'palamu', label: 'Palamu' },
    { value: 'paratdih', label: 'Paratdih' },
    { value: 'patratu', label: 'Patratu' },
    { value: 'phusro', label: 'Phusro' },
    { value: 'ramgarh-cantonment', label: 'Ramgarh Cantonment' },
    { value: 'ranchi', label: 'Ranchi' },
    { value: 'sahibganj', label: 'Sahibganj' },
    { value: 'saraikela', label: 'Saraikela' },
    { value: 'saunda-basti', label: 'Saunda-Basti' },
    { value: 'sirka', label: 'Sirka' },
    { value: 'simdega', label: 'Simdega' },
    { value: 'siuliban', label: 'Siuliban' }
],

  'karnataka': [
    { value: 'arsikere', label: 'Arsikere' },
    { value: 'bagalkote', label: 'Bagalkote' },
    { value: 'bangalore-rural', label: 'Bangalore Rural' },
    { value: 'ballari', label: 'Ballari' },
    { value: 'belagavi', label: 'Belagavi' },
    { value: 'bengaluru', label: 'Bengaluru' },
    { value: 'bhadravathi', label: 'Bhadravathi' },
    { value: 'bidar', label: 'Bidar' },
    { value: 'chamarajanagar', label: 'Chamarajanagar' },
    { value: 'chikkaballapur', label: 'Chikkaballapur' },
    { value: 'chikkamagaluru', label: 'Chikkamagaluru' },
    { value: 'chincholi', label: 'Chincholi' },
    { value: 'chintamani', label: 'Chintamani' },
    { value: 'chitradurga', label: 'Chitradurga' },
    { value: 'davanagere', label: 'Davanagere' },
    { value: 'dharwad', label: 'Dharwad' },
    { value: 'gadag-betageri', label: 'Gadag-Betageri' },
    { value: 'gangavathi', label: 'Gangavathi' },
    { value: 'harapanahalli', label: 'Harapanahalli' },
    { value: 'hassan', label: 'Hassan' },
    { value: 'haveri', label: 'Haveri' },
    { value: 'hosapete', label: 'Hosapete' },
    { value: 'hubballi', label: 'Hubballi' },
    { value: 'ilkal', label: 'Ilkal' },
    { value: 'kalaburagi', label: 'Kalaburagi' },
    { value: 'kolar', label: 'Kolar' },
    { value: 'koppal', label: 'Koppal' },
    { value: 'madikeri', label: 'Madikeri' },
    { value: 'magadi', label: 'Magadi' },
    { value: 'mandya', label: 'Mandya' },
    { value: 'mangaluru', label: 'Mangaluru' },
    { value: 'molakalmuru', label: 'Molakalmuru' },
    { value: 'mysuru', label: 'Mysuru' },
    { value: 'ramanagara', label: 'Ramanagara' },
    { value: 'ranebennur', label: 'Ranebennur' },
    { value: 'raichur', label: 'Raichur' },
    { value: 'robertsonpet', label: 'Robertsonpet' },
    { value: 'sakleshpura', label: 'Sakleshpura' },
    { value: 'shivamogga', label: 'Shivamogga' },
    { value: 'sindhanur', label: 'Sindhanur' },
    { value: 'srirangapatna', label: 'Srirangapatna' },
    { value: 'tumakuru', label: 'Tumakuru' },
    { value: 'udupi', label: 'Udupi' },
    { value: 'uttara-kannada', label: 'Uttara Kannada' },
    { value: 'vijayapura', label: 'Vijayapura' },
    { value: 'yadgir', label: 'Yadgir' }
],
 'kerala': [
    { value: 'adoor', label: 'Adoor' },
    { value: 'alappuzha', label: 'Alappuzha' },
    { value: 'anchal', label: 'Anchal' },
    { value: 'attingal', label: 'Attingal' },
    { value: 'beypore', label: 'Beypore' },
    { value: 'calicut', label: 'Calicut' },
    { value: 'chalakkudy', label: 'Chalakkudy' },
    { value: 'changanassery', label: 'Changanassery' },
    { value: 'chengannur', label: 'Chengannur' },
    { value: 'cherthala', label: 'Cherthala' },
    { value: 'chittur-thathamangalam', label: 'Chittur-Thathamangalam' },
    { value: 'chavakkad', label: 'Chavakkad' },
    { value: 'cochin', label: 'Cochin' },
    { value: 'erattupetta', label: 'Erattupetta' },
    { value: 'kalamassery', label: 'Kalamassery' },
    { value: 'kalpetta', label: 'Kalpetta' },
    { value: 'kanhangad', label: 'Kanhangad' },
    { value: 'kannur', label: 'Kannur' },
    { value: 'kasaragod', label: 'Kasaragod' },
    { value: 'kattappana', label: 'Kattappana' },
    { value: 'kayamkulam', label: 'Kayamkulam' },
    { value: 'kochi', label: 'Kochi' },
    { value: 'kollam', label: 'Kollam' },
    { value: 'kothamangalam', label: 'Kothamangalam' },
    { value: 'kottakkal', label: 'Kottakkal' },
    { value: 'kottarakara', label: 'Kottarakara' },
    { value: 'kottayam', label: 'Kottayam' },
    { value: 'koyilandy', label: 'Koyilandy' },
    { value: 'calicut', label: 'Calicut' },
    { value: 'kozhikode', label: 'Kozhikode' },
    { value: 'kunnamkulam', label: 'Kunnamkulam' },
    { value: 'malappuram', label: 'Malappuram' },
    { value: 'mananthavady', label: 'Mananthavady' },
    { value: 'mannarkkad', label: 'Mannarkkad' },
    { value: 'manjeri', label: 'Manjeri' },
    { value: 'manjeshwaram', label: 'Manjeshwaram' },
    { value: 'maradu', label: 'Maradu' },
    { value: 'mattanur', label: 'Mattanur' },
    { value: 'muvattupuzha', label: 'Muvattupuzha' },
    { value: 'nedumangad', label: 'Nedumangad' },
    { value: 'neyyattinkara', label: 'Neyyattinkara' },
    { value: 'nilambur', label: 'Nilambur' },
    { value: 'nileshwaram', label: 'Nileshwaram' },
    { value: 'ottappalam', label: 'Ottappalam' },
    { value: 'pala', label: 'Pala' },
    { value: 'palakkad', label: 'Palakkad' },
    { value: 'pandalam', label: 'Pandalam' },
    { value: 'paravur', label: 'Paravur' },
    { value: 'pathanamthitta', label: 'Pathanamthitta' },
    { value: 'pattambi', label: 'Pattambi' },
    { value: 'payyanur', label: 'Payyanur' },
    { value: 'perinthalmanna', label: 'Perinthalmanna' },
    { value: 'ponnani', label: 'Ponnani' },
    { value: 'punalur', label: 'Punalur' },
    { value: 'quilon', label: 'Quilon' },
    { value: 'ramanattukara', label: 'Ramanattukara' },
    { value: 'shoranur', label: 'Shoranur' },
    { value: 'srirangapatna', label: 'Srirangapatna' },
    { value: 'taliparamba', label: 'Taliparamba' },
    { value: 'thalassery', label: 'Thalassery' },
    { value: 'thirurangadi', label: 'Thirurangadi' },
    { value: 'thiruvalla', label: 'Thiruvalla' },
    { value: 'thiruvanathapuram', label: 'Thiruvanathapuram' },
    { value: 'trivendrum', label: 'Trivendrum' },
    { value: 'thrippunithura', label: 'Thrippunithura' },
    { value: 'thrissur', label: 'Thrissur' },
    { value: 'tirur', label: 'Tirur' },
    { value: 'tirurangadi', label: 'Tirurangadi' },
    { value: 'thodupuzha', label: 'Thodupuzha' },
    { value: 'trivandrum', label: 'Trivandrum' },
    { value: 'uppala', label: 'Uppala' },
    { value: 'vaikom', label: 'Vaikom' },
    { value: 'varkala', label: 'Varkala' },
    { value: 'vatakara', label: 'Vatakara' },
    { value: 'wadakkancherry', label: 'Wadakkancherry' }
],

  'ladakh': [
    { value: 'chuchoot-gongma', label: 'Chuchoot Gongma' },
    { value: 'chumathang', label: 'Chumathang' },
    { value: 'chushul', label: 'Chushul' },
    { value: 'dah', label: 'Dah' },
    { value: 'damkhar', label: 'Damkhar' },
    { value: 'diskit', label: 'Diskit' },
    { value: 'durbuk', label: 'Durbuk' },
    { value: 'hemis-shukpachan', label: 'Hemis Shukpachan' },
    { value: 'hundar-dog', label: 'Hundar Dog' },
    { value: 'hundri', label: 'Hundri' },
    { value: 'igoo', label: 'Igoo' },
    { value: 'karzok', label: 'Karzok' },
    { value: 'kargil', label: 'Kargil' },
    { value: 'kargyam', label: 'Kargyam' },
    { value: 'kerey', label: 'Kerey' },
    { value: 'khalsar', label: 'Khalsar' },
    { value: 'khalsi', label: 'Khalsi' },
    { value: 'kharnak', label: 'Kharnak' },
    { value: 'kungiam', label: 'Kungiam' },
    { value: 'koyul', label: 'Koyul' },
    { value: 'lamayouro', label: 'Lamayouro' },
    { value: 'leh', label: 'Leh' },
    { value: 'likir', label: 'Likir' },
    { value: 'liktse', label: 'Liktse' },
    { value: 'lingshet', label: 'Lingshet' },
    { value: 'man-pangong', label: 'Man Pangong' },
    { value: 'nyoma', label: 'Nyoma' },
    { value: 'nurla', label: 'Nurla' },
    { value: 'padum', label: 'Padum' },
    { value: 'panamic', label: 'Panamic' },
    { value: 'phey', label: 'Phey' },
    { value: 'photoksar', label: 'Photoksar' },
    { value: 'phuktse', label: 'Phuktse' },
    { value: 'rumbak', label: 'Rumbak' },
    { value: 'samad-rakchan', label: 'Samad Rakchan' },
    { value: 'sankoo', label: 'Sankoo' },
    { value: 'skitmang', label: 'Skitmang' },
    { value: 'stok', label: 'Stok' },
    { value: 'sumoor', label: 'Sumoor' },
    { value: 'suspol', label: 'Suspol' },
    { value: 'tagste', label: 'Tagste' },
    { value: 'taksi', label: 'Taksi' },
    { value: 'taliparamba', label: 'Taliparamba' },
    { value: 'tarchit', label: 'Tarchit' },
    { value: 'tangyar', label: 'Tangyar' },
    { value: 'thang', label: 'Thang' },
    { value: 'tukla', label: 'Tukla' },
    { value: 'turtuk', label: 'Turtuk' },
    { value: 'udmaru', label: 'Udmaru' },
    { value: 'upshi', label: 'Upshi' },
    { value: 'yulchung', label: 'Yulchung' }
],
  'lakshadweep': [
    { value: 'amini', label: 'Amini' },
    { value: 'kavaratti', label: 'Kavaratti' },
    { value: 'minicoy', label: 'Minicoy' },
    { value: 'minicoy-island', label: 'Minicoy Island' }
],

  'madhya-pradesh': [
    { value: 'alirajpur', label: 'Alirajpur' },
    { value: 'anjad', label: 'Anjad' },
    { value: 'barwani', label: 'Barwani' },
    { value: 'barwaha', label: 'Barwaha' },
    { value: 'betul', label: 'Betul' },
    { value: 'bhind', label: 'Bhind' },
    { value: 'bhopal', label: 'Bhopal' },
    { value: 'burhanpur', label: 'Burhanpur' },
    { value: 'chenderi', label: 'Chenderi' },
    { value: 'chhatarpur', label: 'Chhatarpur' },
    { value: 'chhindwara', label: 'Chhindwara' },
    { value: 'chitrakoot', label: 'Chitrakoot' },
    { value: 'damoh', label: 'Damoh' },
    { value: 'datia', label: 'Datia' },
    { value: 'dewas', label: 'Dewas' },
    { value: 'dhar', label: 'Dhar' },
    { value: 'dindori', label: 'Dindori' },
    { value: 'gadarwara', label: 'Gadarwara' },
    { value: 'guna', label: 'Guna' },
    { value: 'gwalior', label: 'Gwalior' },
    { value: 'hoshangabad', label: 'Hoshangabad' },
    { value: 'indore', label: 'Indore' },
    { value: 'itarsi', label: 'Itarsi' },
    { value: 'jabalpur', label: 'Jabalpur' },
    { value: 'katni', label: 'Katni' },
    { value: 'khajuraho', label: 'Khajuraho' },
    { value: 'khandwa', label: 'Khandwa' },
    { value: 'khargone', label: 'Khargone' },
    { value: 'maihar', label: 'Maihar' },
    { value: 'maheshwar', label: 'Maheshwar' },
    { value: 'mandsaur', label: 'Mandsaur' },
    { value: 'mauganj', label: 'Mauganj' },
    { value: 'morena', label: 'Morena' },
    { value: 'murwara', label: 'Murwara' },
    { value: 'nagda', label: 'Nagda' },
    { value: 'narmadapuram', label: 'Narmadapuram' },
    { value: 'narsinghpur', label: 'Narsinghpur' },
    { value: 'neemuch', label: 'Neemuch' },
    { value: 'panna', label: 'Panna' },
    { value: 'pithampur', label: 'Pithampur' },
    { value: 'raisen', label: 'Raisen' },
    { value: 'ratlam', label: 'Ratlam' },
    { value: 'rewa', label: 'Rewa' },
    { value: 'sagar', label: 'Sagar' },
    { value: 'satna', label: 'Satna' },
    { value: 'sehore', label: 'Sehore' },
    { value: 'seoni', label: 'Seoni' },
    { value: 'shahdol', label: 'Shahdol' },
    { value: 'shajapur', label: 'Shajapur' },
    { value: 'shivpuri', label: 'Shivpuri' },
    { value: 'singrauli', label: 'Singrauli' },
    { value: 'ujjain', label: 'Ujjain' },
    { value: 'vidisha', label: 'Vidisha' }
],

'maharashtra': [
    { value: 'ahilya-nagar', label: 'Ahilya Nagar' },
    { value: 'ahmadnagar', label: 'Ahmadnagar' },
    { value: 'akola', label: 'Akola' },
    { value: 'amravati', label: 'Amravati' },
    { value: 'aurangabad', label: 'Aurangabad' },
    { value: 'beed', label: 'Beed' },
    { value: 'bhandara', label: 'Bhandara' },
    { value: 'buldhana', label: 'Buldhana' },
    { value: 'chandrapur', label: 'Chandrapur' },
    { value: 'dhule', label: 'Dhule' },
    { value: 'gadchiroli', label: 'Gadchiroli' },
    { value: 'gondiya', label: 'Gondiya' },
    { value: 'hadgaon', label: 'Hadgaon' },
    { value: 'hingoli', label: 'Hingoli' },
    { value: 'ichalkaranji', label: 'Ichalkaranji' },
    { value: 'indapur', label: 'Indapur' },
    { value: 'jalgaon', label: 'Jalgaon' },
    { value: 'jalna', label: 'Jalna' },
    { value: 'kolhapur', label: 'Kolhapur' },
    { value: 'latur', label: 'Latur' },
    { value: 'malegaon', label: 'Malegaon' },
    { value: 'mumbai', label: 'Mumbai' },
    { value: 'mumbai-suburban', label: 'Mumbai Suburban' },
    { value: 'nagpur', label: 'Nagpur' },
    { value: 'nanded', label: 'Nanded' },
    { value: 'nandgaon', label: 'Nandgaon' },
    { value: 'nandurbar', label: 'Nandurbar' },
    { value: 'nashik', label: 'Nashik' },
    { value: 'osmanabad', label: 'Osmanabad' },
    { value: 'pandharkawada', label: 'Pandharkawada' },
    { value: 'parbhani', label: 'Parbhani' },
    { value: 'pune', label: 'Pune' },
    { value: 'pusad', label: 'Pusad' },
    { value: 'raigad', label: 'Raigad' },
    { value: 'ramtek', label: 'Ramtek' },
    { value: 'ratnagiri', label: 'Ratnagiri' },
    { value: 'sangamner', label: 'Sangamner' },
    { value: 'sangli', label: 'Sangli' },
    { value: 'satara', label: 'Satara' },
    { value: 'sindhudurg', label: 'Sindhudurg' },
    { value: 'solapur', label: 'Solapur' },
    { value: 'thane', label: 'Thane' },
    { value: 'ulhasnagar', label: 'Ulhasnagar' },
    { value: 'vasai-virar', label: 'Vasai-Virar' },
    { value: 'wardha', label: 'Wardha' },
    { value: 'wani', label: 'Wani' },
    { value: 'washim', label: 'Washim' },
    { value: 'yawal', label: 'Yawal' },
    { value: 'yavatmal', label: 'Yavatmal' },
    { value: 'yeola', label: 'Yeola' }
],
  'manipur': [
    { value: 'bishnupur', label: 'Bishnupur' },
    { value: 'chandel', label: 'Chandel' },
    { value: 'churachandpur', label: 'Churachandpur' },
    { value: 'imphal-east', label: 'Imphal East' },
    { value: 'imphal-west', label: 'Imphal West' },
    { value: 'jiribam', label: 'Jiribam' },
    { value: 'kakching', label: 'Kakching' },
    { value: 'kamjong', label: 'Kamjong' },
    { value: 'kangpokpi', label: 'Kangpokpi' },
    { value: 'noney', label: 'Noney' },
    { value: 'pherzawl', label: 'Pherzawl' },
    { value: 'senapati', label: 'Senapati' },
    { value: 'tamenglong', label: 'Tamenglong' },
    { value: 'tengnoupal', label: 'Tengnoupal' },
    { value: 'thoubal', label: 'Thoubal' },
    { value: 'ukhrul', label: 'Ukhrul' }
],
  'meghalaya': [
    { value: 'ampati', label: 'Āmpati' },
    { value: 'baghmara', label: 'Baghmara' },
    { value: 'balāt', label: 'Balāt' },
    { value: 'cherrapunji', label: 'Cherrapunji' },
    { value: 'dalu', label: 'Dalu' },
    { value: 'east-garo-hills', label: 'East Garo Hills' },
    { value: 'east-jaintia-hills', label: 'East Jaintia Hills' },
    { value: 'east-khasi-hills', label: 'East Khasi Hills' },
    { value: 'jowai', label: 'Jowai' },
    { value: 'jorabat', label: 'Jorabat' },
    { value: 'lad-rymbai', label: 'Lad Rymbai' },
    { value: 'laitkynsew', label: 'Laitkynsew' },
    { value: 'laitumkhrah', label: 'Laitumkhrah' },
    { value: 'madanryting.', label: 'Madanryting' },
    { value: 'mairang', label: 'Mairang' },
    { value: 'mawlynnong', label: 'Mawlynnong' },
    { value: 'mawphlang', label: 'Mawphlang' },
    { value: 'mawsynram', label: 'Mawsynram' },
    { value: 'nongalbibra', label: 'Nongalbibra' },
    { value: 'nongmynsong', label: 'Nongmynsong' },
    { value: 'nongpoh', label: 'Nongpoh' },
    { value: 'nongriat', label: 'Nongriat' },
    { value: 'nongstoin', label: 'Nongstoin' },
    { value: 'north-garo-hills', label: 'North Garo Hills' },
    { value: 'resubelpara', label: 'Resubelpara' },
    { value: 'ri-bhoi', label: 'Ri Bhoi' },
    { value: 'shillong', label: 'Shillong' },
    { value: 'south-garo-hills', label: 'South Garo Hills' },
    { value: 'south-west-garo-hills', label: 'South West Garo Hills' },
    { value: 'south-west-khasi-hills', label: 'South West Khasi Hills' },
    { value: 'tura', label: 'Tura' },
    { value: 'west-garo-hills', label: 'West Garo Hills' },
    { value: 'west-jaintia-hills', label: 'West Jaintia Hills' },
    { value: 'west-khasi-hills', label: 'West Khasi Hills' },
    { value: 'williamnagar', label: 'Williamnagar' }
],
  'mizoram': [
    { value: 'aizawl', label: 'Aizawl' },
    { value: 'bairabi', label: 'Bairabi' },
    { value: 'biate', label: 'Biate' },
    { value: 'bilkhawthlir', label: 'Bilkhawthlir' },
    { value: 'bungzung', label: 'Bungzung' },
    { value: 'chalrang', label: 'Chalrang' },
    { value: 'champhai', label: 'Champhai' },
    { value: 'chiahpi', label: 'Chiahpi' },
    { value: 'darlawn', label: 'Darlawn' },
    { value: 'dilkawn', label: 'Dilkawn' },
    { value: 'farkawn', label: 'Farkawn' },
    { value: 'hnahlan', label: 'Hnahlan' },
    { value: 'hnahthial', label: 'Hnahthial' },
    { value: 'hruaikawn-new', label: 'Hruaikawn New' },
    { value: 'keitum', label: 'Keitum' },
    { value: 'kelkang', label: 'Kelkang' },
    { value: 'khualen', label: 'Khualen' },
    { value: 'khawhai', label: 'Khawhai' },
    { value: 'khawzawl', label: 'Khawzawl' },
    { value: 'khuangleng', label: 'Khuangleng' },
    { value: 'kawlkulh', label: 'Kawlkulh' },
    { value: 'lamzawl', label: 'Lamzawl' },
    { value: 'lawngtlai', label: 'Lawngtlai' },
    { value: 'lengpui', label: 'Lengpui' },
    { value: 'lunglei', label: 'Lunglei' },
    { value: 'lungphunlian', label: 'Lungphunlian' },
    { value: 'mamit', label: 'Mamit' },
    { value: 'madanryting', label: 'Madanryting' },
    { value: 'mimbung', label: 'Mimbung' },
    { value: 'minicoy', label: 'Minicoy' },
    { value: 'murlen', label: 'Murlen' },
    { value: 'n.e.khawdungsei', label: 'N.E.Khawdungsei' },
    { value: 'n.kawnpui', label: 'N.Kawnpui' },
    { value: 'n.lungpher', label: 'N.Lungpher' },
    { value: 'neihdawn', label: 'Neihdawn' },
    { value: 'ngopa', label: 'Ngopa' },
    { value: 'north-vanlaiphai', label: 'North Vanlaiphai' },
    { value: 'phullen', label: 'Phullen' },
    { value: 'saitlaw', label: 'Saitlaw' },
    { value: 'saichal', label: 'Saichal' },
    { value: 'samthang-new', label: 'Samthang New' },
    { value: 'serchhip', label: 'Serchhip' },
    { value: 'serkawn', label: 'Serkawn' },
    { value: 'siaha', label: 'Siaha' },
    { value: 'sialsuk', label: 'Sialsuk' },
    { value: 's.khawbung', label: 'S.Khawbung' },
    { value: 'thenzawl', label: 'Thenzawl' },
    { value: 'tlabung', label: 'Tlabung' },
    { value: 'tuipang', label: 'Tuipang' },
    { value: 'vairengte', label: 'Vairengte' },
    { value: 'zawlnuam', label: 'Zawlnuam' }
],
  'nagaland': [
    { value: 'chümoukedima', label: 'Chümoukedima' },
    { value: 'englan', label: 'Englan' },
    { value: 'kohima', label: 'Kohima' },
    { value: 'mokokchung', label: 'Mokokchung' },
    { value: 'mon-village', label: 'Mon Village' },
    { value: 'naginimora-hq', label: 'Naginimora Hq' },
    { value: 'noklak', label: 'Noklak' },
    { value: 'peren', label: 'Peren' },
    { value: 'pfutsero', label: 'Pfutsero' },
    { value: 'phek', label: 'Phek' },
    { value: 'tuensang', label: 'Tuensang' },
    { value: 'wokha', label: 'Wokha' },
    { value: 'zunheboto', label: 'Zunheboto' }
],
  'odisha': [
    { value: 'angul', label: 'Angul' },
    { value: 'athagarh', label: 'Athagarh' },
    { value: 'balangir', label: 'Balangir' },
    { value: 'bargarh', label: 'Bargarh' },
    { value: 'banki', label: 'Banki' },
    { value: 'basudebpur', label: 'Basudebpur' },
    { value: 'bellaguntha', label: 'Bellaguntha' },
    { value: 'bhadrak', label: 'Bhadrak' },
    { value: 'bhatli', label: 'Bhatli' },
    { value: 'bhawanipatna', label: 'Bhawanipatna' },
    { value: 'bhuban', label: 'Bhuban' },
    { value: 'bhubaneswar', label: 'Bhubaneswar' },
    { value: 'bishama-katek', label: 'Bishama Katek' },
    { value: 'birmitrapur', label: 'Birmitrapur' },
    { value: 'baudhgarh', label: 'Baudhgarh' },
    { value: 'dhamanagar', label: 'Dhamanagar' },
    { value: 'deogarh', label: 'Deogarh' },
    { value: 'gopalpur', label: 'Gopalpur' },
    { value: 'hirakud', label: 'Hirakud' },
    { value: 'jagatsinghpur', label: 'Jagatsinghpur' },
    { value: 'jajpur', label: 'Jajpur' },
    { value: 'jashipur', label: 'Jashipur' },
    { value: 'jharsuguda', label: 'Jharsuguda' },
    { value: 'kamakhyanagar', label: 'Kamakhyanagar' },
    { value: 'kalahandi', label: 'Kalahandi' },
    { value: 'kantabanji', label: 'Kantabanji' },
    { value: 'karanjia', label: 'Karanjia' },
    { value: 'kendrapara', label: 'Kendrapara' },
    { value: 'keonjhar', label: 'Keonjhar' },
    { value: 'khallikot', label: 'Khallikot' },
    { value: 'khordha', label: 'Khordha' },
    { value: 'kotpad', label: 'Kotpad' },
    { value: 'konark', label: 'Konark' },
    { value: 'koraput', label: 'Koraput' },
    { value: 'kuchinda', label: 'Kuchinda' },
    { value: 'malkangiri', label: 'Malkangiri' },
    { value: 'nayagarh', label: 'Nayagarh' },
    { value: 'neemuch', label: 'Neemuch' },
    { value: 'nuapada', label: 'Nuapada' },
    { value: 'nowrangpur', label: 'Nowrangpur' },
    { value: 'patnagarh', label: 'Patnagarh' },
    { value: 'puri', label: 'Puri' },
    { value: 'rajgangpur', label: 'Rajgangpur' },
    { value: 'rairangpur', label: 'Rairangpur' },
    { value: 'rayagada', label: 'Rayagada' },
    { value: 'saitlaw', label: 'Saitlaw' },
    { value: 'sambalpur', label: 'Sambalpur' },
    { value: 'balasore', label: 'Balasore' },
    { value: 'sonepur', label: 'Sonepur' },
    { value: 'sundargarh', label: 'Sundargarh' },
    { value: 'titilagarh', label: 'Titilagarh' },
    { value: 'umerkote', label: 'Umerkote' }
],
'puducherry': [
    { value: 'puducherry', label: 'Puducherry' },
    { value: 'ariyankuppam', label: 'Ariyankuppam' },
    { value: 'bahour', label: 'Bahour' },
    { value: 'chettipet', label: 'Chettipet' },
    { value: 'karaikal', label: 'Karaikal' },
    { value: 'katteri', label: 'Katteri' },
    { value: 'mahé', label: 'Mahé' },
    { value: 'mannadipet', label: 'Mannadipet' },
    { value: 'mudaliarpet', label: 'Mudaliarpet' },
    { value: 'muthialpet', label: 'Muthialpet' },
    { value: 'nettapakkam', label: 'Nettapakkam' },
    { value: 'ozhukarai', label: 'Ozhukarai' },
    { value: 'villianur', label: 'Villianur' },
    { value: 'yanam', label: 'Yanam' }
],
  'punjab': [
    { value: 'abohar', label: 'Abohar' },
    { value: 'ajitgarh', label: 'Ajitgarh' },
    { value: 'amloh', label: 'Amloh' },
    { value: 'amritsar', label: 'Amritsar' },
    { value: 'barnala', label: 'Barnala' },
    { value: 'bassi-pathana', label: 'Bassi Pathana' },
    { value: 'bathinda', label: 'Bathinda' },
    { value: 'batala', label: 'Batala' },
    { value: 'dinanagar', label: 'Dinanagar' },
    { value: 'fatehgarh-churian', label: 'Fatehgarh Churian' },
    { value: 'faridkot', label: 'Faridkot' },
    { value: 'fazilka', label: 'Fazilka' },
    { value: 'firozpur', label: 'Firozpur' },
    { value: 'gidderbaha', label: 'Gidderbaha' },
    { value: 'gobindgarh', label: 'Gobindgarh' },
    { value: 'gurdaspur', label: 'Gurdaspur' },
    { value: 'hoshiarpur', label: 'Hoshiarpur' },
    { value: 'jaito', label: 'Jaito' },
    { value: 'jalandhar', label: 'Jalandhar' },
    { value: 'kapurthala', label: 'Kapurthala' },
    { value: 'kasur', label: 'Kasur' },
    { value: 'khamanon', label: 'Khamanon' },
    { value: 'khanna', label: 'Khanna' },
    { value: 'kharar', label: 'Kharar' },
    { value: 'kot-kapura', label: 'Kot Kapura' },
    { value: 'ludhiana', label: 'Ludhiana' },
    { value: 'maler-kotla', label: 'Maler Kotla' },
    { value: 'malout', label: 'Malout' },
    { value: 'mandi-gobindgarh', label: 'Mandi Gobindgarh' },
    { value: 'mansa', label: 'Mansa' },
    { value: 'maur', label: 'Maur' },
    { value: 'moga', label: 'Moga' },
    { value: 'muktsar', label: 'Muktsar' },
    { value: 'nangal', label: 'Nangal' },
    { value: 'nayagaon', label: 'Nayagaon' },
    { value: 'nawanshahr', label: 'Nawanshahr' },
    { value: 'pathankot', label: 'Pathankot' },
    { value: 'patiala', label: 'Patiala' },
    { value: 'patti', label: 'Patti' },
    { value: 'phagwara', label: 'Phagwara' },
    { value: 'rajpura', label: 'Rajpura' },
    { value: 'rampura-phul', label: 'Rampura Phul' },
    { value: 'rupnagar', label: 'Rupnagar' },
    { value: 'sangrur', label: 'Sangrur' },
    { value: 'sansarpur', label: 'Sansarpur' },
    { value: 'shahkot', label: 'Shahkot' },
    { value: 'sri-muktsar-sahib', label: 'Sri Muktsar Sahib' },
    { value: 'sujanpur', label: 'Sujanpur' },
    { value: 'sunam-udham-singh-wala', label: 'Sunam Udham Singh Wala' },
    { value: 'talwandi-sabo', label: 'Talwandi Sabo' },
    { value: 'tapa', label: 'Tapa' },
    { value: 'tarn-taran-sahib', label: 'Tarn Taran Sahib' },
    { value: 'zirakpur', label: 'Zirakpur' },
    { value: 'zira', label: 'Zira' }
],
'rajasthan': [
    { value: 'ajmer', label: 'Ajmer' },
    { value: 'alwar', label: 'Alwar' },
    { value: 'banswara', label: 'Banswara' },
    { value: 'baran', label: 'Baran' },
    { value: 'barmer', label: 'Barmer' },
    { value: 'beawar', label: 'Beawar' },
    { value: 'bharatpur', label: 'Bharatpur' },
    { value: 'bhilwara', label: 'Bhilwara' },
    { value: 'bhiwadi', label: 'Bhiwadi' },
    { value: 'bikaner', label: 'Bikaner' },
    { value: 'bundi', label: 'Bundi' },
    { value: 'chittorgarh', label: 'Chittorgarh' },
    { value: 'churu', label: 'Churu' },
    { value: 'dausa', label: 'Dausa' },
    { value: 'didwana', label: 'Didwana' },
    { value: 'dholpur', label: 'Dholpur' },
    { value: 'dungarpur', label: 'Dungarpur' },
    { value: 'gangapur', label: 'Gangapur' },
    { value: 'hanumangarh', label: 'Hanumangarh' },
    { value: 'hindaun', label: 'Hindaun' },
    { value: 'jaisalmer', label: 'Jaisalmer' },
    { value: 'jaipur', label: 'Jaipur' },
    { value: 'jalor', label: 'Jalor' },
    { value: 'jhalawar', label: 'Jhalawar' },
    { value: 'jhunjhunu', label: 'Jhunjhunu' },
    { value: 'jodhpur', label: 'Jodhpur' },
    { value: 'karauli', label: 'Karauli' },
    { value: 'kekri', label: 'Kekri' },
    { value: 'kishangarh', label: 'Kishangarh' },
    { value: 'kotputli', label: 'Kotputli' },
    { value: 'kota', label: 'Kota' },
    { value: 'nagaur', label: 'Nagaur' },
    { value: 'pali', label: 'Pali' },
    { value: 'pratapgarh', label: 'Pratapgarh' },
    { value: 'pushkar', label: 'Pushkar' },
    { value: 'rajsamand', label: 'Rajsamand' },
    { value: 'ratangarh', label: 'Ratangarh' },
    { value: 'salumbar', label: 'Salumbar' },
    { value: 'sawai-madhopur', label: 'Sawai Madhopur' },
    { value: 'sikar', label: 'Sikar' },
    { value: 'sirohi', label: 'Sirohi' },
    { value: 'shahpura', label: 'Shahpura' },
    { value: 'sri-ganganagar', label: 'Sri Ganganagar' },
    { value: 'sujangarh', label: 'Sujangarh' },
    { value: 'tonk', label: 'Tonk' },
    { value: 'udaipur', label: 'Udaipur' }
],

'sikkim': [
    { value: 'assangthang', label: 'Assangthang' },
    { value: 'barnyak', label: 'Barnyak' },
    { value: 'bikmat', label: 'Bikmat' },
    { value: 'chalamthang', label: 'Chalamthang' },
    { value: 'chungthang', label: 'Chungthang' },
    { value: 'damthang', label: 'Damthang' },
    { value: 'darap', label: 'Darap' },
    { value: 'dikchu', label: 'Dikchu' },
    { value: 'gangtok', label: 'Gangtok' },
    { value: 'geyzing', label: 'Geyzing' },
    { value: 'gyalshing', label: 'Gyalshing' },
    { value: 'jorethang', label: 'Jorethang' },
    { value: 'kaluk', label: 'Kaluk' },
    { value: 'khamdong', label: 'Khamdong' },
    { value: 'lachen', label: 'Lachen' },
    { value: 'lachung', label: 'Lachung' },
    { value: 'lingthem', label: 'Lingthem' },
    { value: 'majitar', label: 'Majitar' },
    { value: 'mangan', label: 'Mangan' },
    { value: 'namchi', label: 'Namchi' },
    { value: 'namthang', label: 'Namthang' },
    { value: 'nayabazar', label: 'Nayabazar' },
    { value: 'pakyong', label: 'Pakyong' },
    { value: 'pedong', label: 'Pedong' },
    { value: 'pelling', label: 'Pelling' },
    { value: 'phodong', label: 'Phodong' },
    { value: 'rabdentse', label: 'Rabdentse' },
    { value: 'rangpo', label: 'Rangpo' },
    { value: 'ravangla', label: 'Ravangla' },
    { value: 'rhenak', label: 'Rhenak' },
    { value: 'rhenock', label: 'Rhenock' },
    { value: 'rinchenpong', label: 'Rinchenpong' },
    { value: 'rongli', label: 'Rongli' },
    { value: 'sevoke', label: 'Sevoke' },
    { value: 'singhik', label: 'Singhik' },
    { value: 'singtam', label: 'Singtam' },
    { value: 'soreng', label: 'Soreng' },
    { value: 'sumbuk', label: 'Sumbuk' },
    { value: 'tarku', label: 'Tarku' },
    { value: 'tinkitam', label: 'Tinkitam' },
    { value: 'tumlong', label: 'Tumlong' },
    { value: 'upper-tadong', label: 'Upper Tadong' },
    { value: 'yangang', label: 'Yangang' },
    { value: 'yuksom', label: 'Yuksom' },
    { value: 'zuluk', label: 'Zuluk' }
],

  'tamil-nadu': [
    { value: 'alanthurai', label: 'Alanthurai' },
    { value: 'arcot', label: 'Arcot' },
    { value: 'ariyalur', label: 'Ariyalur' },
    { value: 'aruppukkottai', label: 'Aruppukkottai' },
    { value: 'chengalpattu', label: 'Chengalpattu' },
    { value: 'chennai', label: 'Chennai' },
    { value: 'cheyyar', label: 'Cheyyar' },
    { value: 'chidambaram', label: 'Chidambaram' },
    { value: 'chinnamanur', label: 'Chinnamanur' },
    { value: 'coimbatore', label: 'Coimbatore' },
    { value: 'cumbum', label: 'Cumbum' },
    { value: 'dharapuram', label: 'Dharapuram' },
    { value: 'dharmapuri', label: 'Dharmapuri' },
    { value: 'edappadi', label: 'Edappadi' },
    { value: 'erode', label: 'Erode' },
    { value: 'gudalur', label: 'Gudalur' },
    { value: 'kanchipuram', label: 'Kanchipuram' },
    { value: 'kallidaikurchi', label: 'Kallidaikurchi' },
    { value: 'kanniyakumari', label: 'Kanniyakumari' },
    { value: 'koundampalayam', label: 'Koundampalayam' },
    { value: 'kuniyamuthur', label: 'Kuniyamuthur' },
    { value: 'madurai', label: 'Madurai' },
    { value: 'melur', label: 'Melur' },
    { value: 'mettur', label: 'Mettur' },
    { value: 'minjur', label: 'Minjur' },
    { value: 'musiri', label: 'Musiri' },
    { value: 'nagercoil', label: 'Nagercoil' },
    { value: 'nagapattinam', label: 'Nagapattinam' },
    { value: 'namakkal', label: 'Namakkal' },
    { value: 'palani', label: 'Palani' },
    { value: 'ponneri', label: 'Ponneri' },
    { value: 'rameswaram', label: 'Rameswaram' },
    { value: 'ramanathapuram', label: 'Ramanathapuram' },
    { value: 'salem', label: 'Salem' },
    { value: 'sivaganga', label: 'Sivaganga' },
    { value: 'thanjavur', label: 'Thanjavur' },
    { value: 'thoothukudi', label: 'Thoothukudi' },
    { value: 'tiruchirappalli', label: 'Tiruchirappalli' },
    { value: 'tirunelveli', label: 'Tirunelveli' },
    { value: 'tiruvottiyur', label: 'Tiruvottiyur' },
    { value: 'vellore', label: 'Vellore' },
    { value: 'viluppuram', label: 'Viluppuram' },
    { value: 'virudhunagar', label: 'Virudhunagar' },
    { value: 'walajapet', label: 'Walajapet' }
],
  'telangana': [
    { value: 'achampet', label: 'Achampet' },
    { value: 'adilabad', label: 'Adilabad' },
    { value: 'alampur', label: 'Alampur' },
    { value: 'armoor', label: 'Armoor' },
    { value: 'asifabad', label: 'Asifabad' },
    { value: 'badepalle', label: 'Badepalle' },
    { value: 'banswada', label: 'Banswada' },
    { value: 'bellal-tarafa', label: 'Bellal Tarafa' },
    { value: 'bellampalle', label: 'Bellampalle' },
    { value: 'bhainsa', label: 'Bhainsa' },
    { value: 'bhupalpally', label: 'Bhupalpally' },
    { value: 'bhuvanagiri', label: 'Bhuvanagiri' },
    { value: 'devarakanda', label: 'Devarakanda' },
    { value: 'gadwal', label: 'Gadwal' },
    { value: 'gajwel', label: 'Gajwel' },
    { value: 'hanamkanda', label: 'Hanamkanda' },
    { value: 'hyderabad', label: 'Hyderabad' },
    { value: 'jagtial', label: 'Jagtial' },
    { value: 'jangaon', label: 'Jangaon' },
    { value: 'kagaznagar', label: 'Kagaznagar' },
    { value: 'kamareddy', label: 'Kamareddy' },
    { value: 'karimnagar', label: 'Karimnagar' },
    { value: 'khammam', label: 'Khammam' },
    { value: 'kothagudem', label: 'Kothagudem' },
    { value: 'kyathanpally', label: 'Kyathanpally' },
    { value: 'mahabubabad', label: 'Mahabubabad' },
    { value: 'mahbubnagar', label: 'Mahbubnagar' },
    { value: 'madhira', label: 'Madhira' },
    { value: 'mandamarri', label: 'Mandamarri' },
    { value: 'mancherial', label: 'Mancherial' },
    { value: 'manuguru', label: 'Manuguru' },
    { value: 'medak', label: 'Medak' },
    { value: 'mulugu', label: 'Mulugu' },
    { value: 'nagarkurnool', label: 'Nagarkurnool' },
    { value: 'nakrekal', label: 'Nakrekal' },
    { value: 'nalgonda', label: 'Nalgonda' },
    { value: 'narsampet', label: 'Narsampet' },
    { value: 'narayanpet', label: 'Narayanpet' },
    { value: 'nirmal', label: 'Nirmal' },
    { value: 'nizamabad', label: 'Nizamabad' },
    { value: 'peddapalli', label: 'Peddapalli' },
    { value: 'ramagundam', label: 'Ramagundam' },
    { value: 'sangareddy', label: 'Sangareddy' },
    { value: 'serilingampalle', label: 'Serilingampalle' },
    { value: 'shamshabad', label: 'Shamshabad' },
    { value: 'siddipet', label: 'Siddipet' },
    { value: 'siricilla', label: 'Siricilla' },
    { value: 'suryapet', label: 'Suryapet' },
    { value: 'tandur', label: 'Tandur' },
    { value: 'vemulawada', label: 'Vemulawada' },
    { value: 'vikarabad', label: 'Vikarabad' },
    { value: 'wanaparthy', label: 'Wanaparthy' },
    { value: 'warangal', label: 'Warangal' },
    { value: 'yellandu', label: 'Yellandu' }
],

  'tripura': [
    { value: 'agartala', label: 'Agartala' },
    { value: 'ambassa', label: 'Ambassa' },
    { value: 'belbari', label: 'Belbari' },
    { value: 'belonia', label: 'Belonia' },
    { value: 'bishalgarh', label: 'Bishalgarh' },
    { value: 'dharmanagar', label: 'Dharmanagar' },
    { value: 'dukli', label: 'Dukli' },
    { value: 'gomati', label: 'Gomati' },
    { value: 'hezamara', label: 'Hezamara' },
    { value: 'hrishyamukh', label: 'Hrishyamukh' },
    { value: 'jirania', label: 'Jirania' },
    { value: 'jolaibari', label: 'Jolaibari' },
    { value: 'kadamtala.', label: 'Kadamtala' },
    { value: 'kailashahar', label: 'Kailashahar' },
    { value: 'kamalpur', label: 'Kamalpur' },
    { value: 'mohanpur', label: 'Mohanpur' },
    { value: 'north-tripura', label: 'North Tripura' },
    { value: 'sabroom', label: 'Sabroom' },
    { value: 'sonamura', label: 'Sonamura' },
    { value: 'udaipur', label: 'Udaipur' }
],
  'uttar-pradesh': [
    { value: 'agra', label: 'Agra' },
    { value: 'aligarh', label: 'Aligarh' },
    { value: 'allahabad', label: 'Allahabad' },
    { value: 'amethi', label: 'Amethi' },
    { value: 'ambedkar-nagar', label: 'Ambedkar Nagar' },
    { value: 'amroha', label: 'Amroha' },
    { value: 'auraiya', label: 'Auraiya' },
    { value: 'azamgarh', label: 'Azamgarh' },
    { value: 'baghpat', label: 'Baghpat' },
    { value: 'bahraich', label: 'Bahraich' },
    { value: 'ballia', label: 'Ballia' },
    { value: 'balrampur', label: 'Balrampur' },
    { value: 'banda', label: 'Banda' },
    { value: 'barabanki', label: 'Barabanki' },
    { value: 'bareilly', label: 'Bareilly' },
    { value: 'basti', label: 'Basti' },
    { value: 'bijnor', label: 'Bijnor' },
    { value: 'budaun', label: 'Budaun' },
    { value: 'chandauli', label: 'Chandauli' },
    { value: 'chitrakoot', label: 'Chitrakoot' },
    { value: 'deoria', label: 'Deoria' },
    { value: 'etah', label: 'Etah' },
    { value: 'etawah', label: 'Etawah' },
    { value: 'faizabad', label: 'Faizabad' },
    { value: 'farrukhabad', label: 'Farrukhabad' },
    { value: 'fatehpur', label: 'Fatehpur' },
    { value: 'firozabad', label: 'Firozabad' },
    { value: 'gautam-buddh-nagar', label: 'Gautam Buddh Nagar' },
    { value: 'ghaziabad', label: 'Ghaziabad' },
    { value: 'ghazipur', label: 'Ghazipur' },
    { value: 'gonda', label: 'Gonda' },
    { value: 'gorakhpur', label: 'Gorakhpur' },
    { value: 'hamirpur', label: 'Hamirpur' },
    { value: 'hapur', label: 'Hapur' },
    { value: 'hardoi', label: 'Hardoi' },
    { value: 'hathras', label: 'Hathras' },
    { value: 'jalaun', label: 'Jalaun' },
    { value: 'jaunpur', label: 'Jaunpur' },
    { value: 'jhansi', label: 'Jhansi' },
    { value: 'amroha ', label: 'Amroha' },
    { value: 'kannauj', label: 'Kannauj' },
    { value: 'kanpur', label: 'Kanpur' },
    { value: 'kanpur-nagar', label: 'Kanpur Nagar' },
    { value: 'kasganj', label: 'Kasganj' },
    { value: 'kaushambi', label: 'Kaushambi' },
    { value: 'lakhimpur', label: 'Lakhimpur' },
    { value: 'kushinagar', label: 'Kushinagar' },
    { value: 'lalitpur', label: 'Lalitpur' },
    { value: 'lucknow', label: 'Lucknow' },
    { value: 'maharajganj', label: 'Maharajganj' },
    { value: 'mahoba', label: 'Mahoba' },
    { value: 'mainpuri', label: 'Mainpuri' },
    { value: 'mathura', label: 'Mathura' },
    { value: 'mau', label: 'Mau' },
    { value: 'meerut', label: 'Meerut' },
    { value: 'mirzapur', label: 'Mirzapur' },
    { value: 'moradabad', label: 'Moradabad' },
    { value: 'muzaffarnagar', label: 'Muzaffarnagar' },
    { value: 'noida', label: 'Noida' },
    { value: 'pilibhit', label: 'Pilibhit' },
    { value: 'pratapgarh.', label: 'Pratapgarh' },
    { value: 'prayagraj', label: 'Prayagraj' },
    { value: 'raebareli', label: 'Raebareli' },
    { value: 'rampur', label: 'Rampur' },
    { value: 'saharanpur', label: 'Saharanpur' },
    { value: 'sant-kabir-nagar', label: 'Sant Kabir Nagar' },
    { value: 'bhadohi ', label: 'Bhadohi ' },
    { value: 'shahjahanpur', label: 'Shahjahanpur' },
    { value: 'siddharthnagar', label: 'Siddharthnagar' },
    { value: 'sitapur', label: 'Sitapur' },
    { value: 'sonbhadra', label: 'Sonbhadra' },
    { value: 'sultanpur', label: 'Sultanpur' },
    { value: 'unnao', label: 'Unnao' },
    { value: 'varanasi', label: 'Varanasi' }
],
  'uttarakhand': [
    { value: 'almora', label: 'Almora' },
    { value: 'badrinath', label: 'Badrinath' },
    { value: 'bageshwar', label: 'Bageshwar' },
    { value: 'champawat', label: 'Champawat' },
    { value: 'dehradun', label: 'Dehradun' },
    { value: 'dharchula', label: 'Dharchula' },
    { value: 'gairsain', label: 'Gairsain' },
    { value: 'gangotri', label: 'Gangotri' },
    { value: 'haldwani', label: 'Haldwani' },
    { value: 'haridwar', label: 'Haridwar' },
    { value: 'harsil', label: 'Harsil' },
    { value: 'kashipur', label: 'Kashipur' },
    { value: 'kedarnath', label: 'Kedarnath' },
    { value: 'kotdwar', label: 'Kotdwar' },
    { value: 'laksar', label: 'Laksar' },
    { value: 'landour', label: 'Landour' },
    { value: 'nainital', label: 'Nainital' },
    { value: 'pantnagar', label: 'Pantnagar' },
    { value: 'pithoragarh', label: 'Pithoragarh' },
    { value: 'ramnagar', label: 'Ramnagar' },
    { value: 'roorkee', label: 'Roorkee' },
    { value: 'rudraprayag', label: 'Rudraprayag' },
    { value: 'uttarkashi', label: 'Uttarkashi' }
],
  'west-bengal': [
    { value: 'alipurduar', label: 'Alipurduar' },
    { value: 'asansol', label: 'Asansol' },
    { value: 'baidyabati', label: 'Baidyabati' },
    { value: 'baduria', label: 'Baduria' },
    { value: 'bally', label: 'Bally' },
    { value: 'balurghat', label: 'Balurghat' },
    { value: 'bangaon', label: 'Bangaon' },
    { value: 'bankura', label: 'Bankura' },
    { value: 'baranagar', label: 'Baranagar' },
    { value: 'barasat', label: 'Barasat' },
    { value: 'bardhaman', label: 'Bardhaman' },
    { value: 'barrackpur-cantonment', label: 'Barrackpur Cantonment' },
    { value: 'basirhat', label: 'Basirhat' },
    { value: 'berhampore', label: 'Berhampore' },
    { value: 'bhadreswar', label: 'Bhadreswar' },
    { value: 'bidhannagar', label: 'Bidhannagar' },
    { value: 'birbhum', label: 'Birbhum' },
    { value: 'chandannagar', label: 'Chandannagar' },
    { value: 'chinsurah', label: 'Chinsurah' },
    { value: 'cooch-behar', label: 'Cooch Behar' },
    { value: 'darjeeling', label: 'Darjeeling' },
    { value: 'deogarh', label: 'Deogarh' },
    { value: 'dhupguri', label: 'Dhupguri' },
    { value: 'dubrajpur', label: 'Dubrajpur' },
    { value: 'dum-dum', label: 'Dum Dum' },
    { value: 'durgapur', label: 'Durgapur' },
    { value: 'egra', label: 'Egra' },
    { value: 'haldia', label: 'Haldia' },
    { value: 'hooghly', label: 'Hooghly' },
    { value: 'howrah', label: 'Howrah' },
    { value: 'jalpaiguri', label: 'Jalpaiguri' },
    { value: 'jamuria', label: 'Jamuria' },
    { value: 'jaynagar-mazilpur', label: 'Jaynagar Mazilpur' },
    { value: 'jhargram', label: 'Jhargram' },
    { value: 'kalimpong', label: 'Kalimpong' },
    { value: 'kalyani', label: 'Kalyani' },
    { value: 'kamarhati', label: 'Kamarhati' },
    { value: 'kanchrapara', label: 'Kanchrapara' },
    { value: 'khardaha', label: 'Khardaha' },
    { value: 'kolkata', label: 'Kolkata' },
    { value: 'krishnanagar', label: 'Krishnanagar' },
    { value: 'malda', label: 'Malda' },
    { value: 'maheshtala', label: 'Maheshtala' },
    { value: 'mathabhanga', label: 'Mathabhanga' },
    { value: 'midnapore', label: 'Midnapore' },
    { value: 'nabadwip', label: 'Nabadwip' },
    { value: 'nadia', label: 'Nadia' },
    { value: 'naihati', label: 'Naihati' },
    { value: 'north-24-parganas', label: 'North 24 Parganas' },
    { value: 'panihati', label: 'Panihati' },
    { value: 'patnagarh', label: 'Patnagarh' },
    { value: 'purba-bardhaman', label: 'Purba Bardhaman' },
    { value: 'purulia', label: 'Purulia' },
    { value: 'raiganj', label: 'Raiganj' },
    { value: 'ranaghat', label: 'Ranaghat' },
    { value: 'santipur', label: 'Santipur' },
    { value: 'serampore', label: 'Serampore' },
    { value: 'siliguri', label: 'Siliguri' },
    { value: 'suri', label: 'Suri' },
    { value: 'titagarh', label: 'Titagarh' },
    { value: 'uluberia', label: 'Uluberia' },
    { value: 'uttarpara', label: 'Uttarpara' }
]
};

// Helper functions
export function getCitiesByState(state: StateValue): CityList {
  return cities[state] || [];
}

export function getCityLabel(state: StateValue, cityValue: string): string {
  const city = cities[state]?.find(city => city.value === cityValue);
  return city?.label || cityValue;
}